import { Close } from '@mui/icons-material'
import { useState } from 'react'

import { CloseButton, ContainerMessage, TextContainer } from './styles'

function Alert({
    onClose,
    icon,
    children
}: {
    onClose?: () => any
    icon?: React.ReactNode
    children?: React.ReactNode
}) {
    const [open, setOpen] = useState(true)

    return (
        <ContainerMessage role="alert" showAlert={open}>
            {!!icon && <span role="img">{icon}</span>}
            <TextContainer role="contentinfo">{children}</TextContainer>
            <CloseButton
                role="button"
                onClick={() => {
                    setOpen(false)
                    if (!!onClose) onClose()
                }}
            >
                <Close />
            </CloseButton>
        </ContainerMessage>
    )
}

export default Alert
